import { render, staticRenderFns } from "./HiddenProjectList.vue?vue&type=template&id=12ff365d&scoped=true&"
import script from "./HiddenProjectList.vue?vue&type=script&lang=ts&"
export * from "./HiddenProjectList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff365d",
  null
  
)

export default component.exports